import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { cn } from "@/lib/utils";
import {
  LANG_STORAGE_KEY,
  Lang,
  basePathname,
  langPath,
  useLang,
} from "@/i18n";

// Base routes that exist in both language trees; everything else falls back to home.
const SWITCHABLE_PATHS = ["/", "/imprint", "/privacy-policy"];

interface LanguageSwitcherProps {
  className?: string;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  className,
}) => {
  const lang = useLang();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const switchTo = (target: Lang) => {
    if (target === lang) return;
    try {
      localStorage.setItem(LANG_STORAGE_KEY, target);
    } catch {
      /* private mode etc. - preference just won't persist */
    }
    const base = basePathname(pathname);
    navigate(langPath(SWITCHABLE_PATHS.includes(base) ? base : "/", target));
  };

  return (
    <div
      className={cn(
        "flex items-center text-[13px] font-semibold tracking-wide",
        className,
      )}
    >
      <button
        aria-label="Deutsch"
        onClick={() => switchTo("de")}
        className={cn(
          "px-1 py-2 transition-colors",
          lang === "de" ? "text-[#01C6FB]" : "text-base-400 hover:text-white",
        )}
      >
        DE
      </button>
      <span className="text-white/20">|</span>
      <button
        aria-label="English"
        onClick={() => switchTo("en")}
        className={cn(
          "px-1 py-2 transition-colors",
          lang === "en" ? "text-[#01C6FB]" : "text-base-400 hover:text-white",
        )}
      >
        EN
      </button>
    </div>
  );
};
